import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { Card } from '@/components/ds';
import { cn } from '@/lib/utils';

export type EmptyStateProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  secondaryAction?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  secondaryAction,
  size = 'md',
  className,
}: EmptyStateProps) {
  const padding = { sm: 'py-8', md: 'py-12', lg: 'py-16' }[size];
  const iconStroke = 1.5;
  const iconSize = { sm: 24, md: 28, lg: 32 }[size];
  const titleClass = { sm: 'text-base', md: 'text-lg', lg: 'text-xl' }[size];

  return (
    <Card className={cn('flex flex-col items-center text-center px-6', padding, className)}>
      <div className="w-16 h-16 rounded-full bg-accent-soft flex items-center justify-center mb-4">
        <Icon size={iconSize} className="text-accent" strokeWidth={iconStroke} />
      </div>
      <h3 className={cn('font-semibold text-text-primary mb-2', titleClass)}>{title}</h3>
      <p className="text-text-secondary text-sm leading-relaxed max-w-md mb-6">
        {description}
      </p>
      {(action || secondaryAction) && (
        <div className="flex flex-col sm:flex-row gap-2 items-center">
          {action}
          {secondaryAction}
        </div>
      )}
    </Card>
  );
}
